import { AxiosReports, AxiosReportLas } from '../config';

interface GenerateExcelParams {
  empresa: number | string;
  login: string;
  dataInicial?: string;
  dataFinal?: string;
  unidades: number[];
  ocorrenciasEmAberto: boolean;
  ocorrenciasAuditoria: boolean;
  ocorrenciasAtrasadas: boolean;
  sistemas: string[];
  statusOcorrencias: number[];
  materiais: boolean;
}

interface GeneratePDFParams {
  companyId: number | string;
  unitGroups: any;
  unitSubgroups: any;
  states: any;
  systems: string[];
  units: number[];
  showOnlyOpenOccurrences: boolean;
  showAuditOccurrence: boolean;
  showOnlyDelayedOccurrences: boolean;
  period: any;
  status: any;
  people: any;
  local: any;
  prioritization: any;
  occurrences: any;
  corrections: any;
  metrics?: any;
  userId: number;
  token: string;
}

const OccurrenceService = {
  validateLogin: (login: string) => {
    return AxiosReportLas({
      method: 'post',
      url: `/v1/Relatorios/ValidarEmailUsuario?login=${login}`,
      headers: { 'content-type': 'application/json' },
    });
  },

  sendExcelByEmail: (params: GenerateExcelParams) => {
    const {
      empresa,
      login,
      dataInicial,
      dataFinal,
      unidades,
      ocorrenciasEmAberto,
      ocorrenciasAuditoria,
      ocorrenciasAtrasadas,
      sistemas,
      statusOcorrencias,
      materiais,
    } = params;
    return AxiosReportLas({
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        EmpresaId: empresa,
      },
      url: '/v1/Relatorios/Ocorrencias',
      data: {
        login,
        empresa,
        dataInicial,
        dataFinal,
        listUnidadesId: unidades,
        ocorrenciasEmAberto,
        ocorrenciasAuditoria,
        ocorrenciasAtrasadas,
        sistemas,
        statusOcorrencias,
        materiais,
      },
    });
  },

  generatePDF: (params: GeneratePDFParams) => {
    const { companyId, ...rest } = params;
    return AxiosReports({
      method: 'post',
      responseType: 'blob',
      url: `occurrences/pdf/${companyId}`,
      data: rest,
    });
  },
};

export { OccurrenceService };
